<template>
<div class="chapter">
<div class="inner_page">
<div class="image-break">
<p class="image"><img alt="Images" src="images/P4.jpg"/></p>
<p class="caption">The Cecil Hotel sign, 2021. <i>Courtesy of Sean Kanan.</i></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Page4.vue?3f208a2e